export default __webpack_public_path__ + "static/media/fondo-clientes-2.394fdab3.png";